export default "__VITE_ASSET__BmxyFkmY__"